var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Logs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Logs",
    stroke: "#B5B5B5",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7888544,5.59123552 L19.2749469,16.5634206 C19.7689254,17.5513776 19.3684767,18.7527236 18.3805197,19.2467021 C18.1028088,19.3855576 17.7965827,19.4578478 17.4860925,19.4578478 L6.51390748,19.4578478 C5.40933798,19.4578478 4.51390748,18.5624173 4.51390748,17.4578478 C4.51390748,17.1473576 4.58619766,16.8411314 4.7250531,16.5634206 L10.2111456,5.59123552 C10.7051241,4.60327853 11.9064702,4.20282983 12.8944272,4.69680833 C13.281482,4.89033573 13.595327,5.20418072 13.7888544,5.59123552 Z",
    id: "Triangle"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8.55036076,
    x2: 12,
    y2: 13.355952,
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16.410984,
    x2: 12,
    y2: 15.8465338,
    id: "Path-7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/Logs.4d580ddc.svg";
export { ForwardRef as ReactComponent };